import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { GlobalServiceProvider } from '..';

/*
  Generated class for the SilosServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SilosServiceProvider {
  baseUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;

  constructor(
    public http: Http,
    public globalServiceProvider: GlobalServiceProvider, 
  ) {
    console.log('Hello SilosServiceProvider Provider');
  }

  getSiloStatus() {
    let result = null;
    return this.http
      .get(this.baseUrl + '/api/ignition/getsilostatus')
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getSiloInfo(customer) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/silos', { customer: customer })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getInboundInfo(customer, page) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/loadin', { customer: customer, pageNo: page.pageNo, limit: page.limit })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getFilterInboundInfo(customer, NML, page) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/getfilterloadin', { customer: customer, NML: NML, pageNo: page.pageNo, limit: page.limit })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }


  getOutboundInfo(customer, page) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/loadout', { customer: customer, pageNo: page.pageNo, limit: page.limit })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getJobByReference(custCode, referenceNo) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/jobs/reference', { custCode: custCode, referenceNumber: referenceNo })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getFilterOutboundInfo(customer, CustomerReference, page) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/getfilterloadout', { customer: customer, CustomerReference: CustomerReference, pageNo: page.pageNo, limit: page.limit })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getConciliation(customer, startDate, endDate) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/getbalance', { customer: customer, startDate: startDate, endDate: endDate })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getInboundInfoData(customer, startDate, endDate) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/loadindata', { customer: customer, startDate: startDate, endDate: endDate })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getOutboundInfoData(customer, startDate, endDate) {
    let result = null;
    return this.http
      .post(this.baseUrl + '/api/ignition/loadoutdata', { customer: customer, startDate: startDate, endDate: endDate })
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getCustomerbyJobId(JobId){
    let result = null;
    return this.http
        .get(this.baseUrl + '/api/getcustomerbyjobid/' + JobId)
        .toPromise()
        .then(data => {
            result = data.json();
            return result;
        }
        )
        .catch(
            err => {
                return null;
            }
        );
  }
}



// WEBPACK FOOTER //
// ./src/providers/silos-service/silos-service.ts